import { render, staticRenderFns } from "./ViewSpace.vue?vue&type=template&id=99905a30&scoped=true&"
import script from "./ViewSpace.vue?vue&type=script&lang=js&"
export * from "./ViewSpace.vue?vue&type=script&lang=js&"
import style0 from "./ViewSpace.vue?vue&type=style&index=0&id=99905a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99905a30",
  null
  
)

export default component.exports